import { createMigration } from './utils';

/**
 * Sets isEditable to true for AssetGroups that have color or alpha graphics
 */
function setIsEditableForAssetGroup(map: any, path: Array<string | number>) {
    const asset = map.getIn(path) as any;
    if (!asset) {
        return;
    }

    const classType = asset.get('classType');
    if (classType !== 'AssetGroup') {
        return;
    }

    const colorGraphics = asset.get('colorGraphics');
    const alphaGraphics = asset.get('alphaGraphics');

    if (
        (!colorGraphics || colorGraphics.size === 0) &&
        (!alphaGraphics || alphaGraphics.size === 0)
    ) {
        return;
    }

    map.setIn([...path, 'isEditable'], true);
}

export const migrationTo9_230 = createMigration({
    migrateVideo(video) {
        return video.withMutations((map) => {
            map.get('slides').forEach((scene: any, i: number) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene) {
        return scene.withMutations((map) => {
            const children = map.get('children');
            if (children) {
                children.forEach((_child: any, cIndex: number) => {
                    setIsEditableForAssetGroup(map, ['children', cIndex]);
                });
            }

            const subslides = map.get('subslides');
            if (subslides) {
                subslides.forEach((_subslide: any, sIndex: number) => {
                    const subslide = map.getIn(['subslides', sIndex]) as any;
                    if (!subslide) {
                        return;
                    }

                    const subslideChildren = subslide.get('children');
                    if (subslideChildren) {
                        subslideChildren.forEach((_child: any, cIndex: number) => {
                            setIsEditableForAssetGroup(map, [
                                'subslides',
                                sIndex,
                                'children',
                                cIndex,
                            ]);
                        });
                    }
                });
            }
        });
    },
});
